import { render } from "./ModeratorsView.vue?vue&type=template&id=1eb7e313&scoped=true&ts=true"
import script from "./ModeratorsView.vue?vue&type=script&lang=ts"
export * from "./ModeratorsView.vue?vue&type=script&lang=ts"

import "./ModeratorsView.vue?vue&type=style&index=0&id=1eb7e313&lang=scss&scoped=true"

import exportComponent from "/working_dir/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1eb7e313"]])

export default __exports__